const autoNgTemplateLoaderTemplate1 = require('./kube-custom-templates-view.html');

import controller from './kube-custom-templates-view.controller.js';

export const kubeCustomTemplatesView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
